import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { withRouter } from 'react-router-dom';
import { reportMessage } from '../../messages/messageActions';


import ReportMessage from './ReportMessage';

const mapStateToProps = state => ({ 
    memberId: state.memberId
});

const mapDispatchToProps = dispatch => bindActionCreators({
    reportMessage
 }, dispatch);

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    Form.create()
)(ReportMessage);